export enum InternetHeader {
    FilingLocationNrn = "X-Newforma-FilingLocationNrn",
    EmailId = "X-Newforma-EmailId",
}
